import { Lock } from "lucide-react";

export const StripeSecurityNote = ({ className = "", compact = false }) => (
  <div
    className={`rounded-xl border border-[#5F8F87]/25 bg-[#F7F2E8] px-4 py-3 ${className}`}
    data-testid="stripe-security-note"
    role="note"
  >
    <p className="flex items-center gap-2 text-sm font-semibold text-[#1C1C1C]">
      <Lock size={15} className="shrink-0 text-[#5F8F87]" aria-hidden="true" />
      <span>Secure payment processed by Stripe</span>
    </p>
    {!compact && (
      <p className="mt-1 pl-[23px] text-xs leading-relaxed text-[#1C1C1C]/70">
        Your payment information is encrypted and handled securely by{" "}
        <span className="text-[#B87333]">Stripe</span>. Masaya Hospitality Cleaning Services does not store your full card number.
      </p>
    )}
  </div>
);

export default StripeSecurityNote;
